import { Injectable } from '@angular/core';
import { Http, Wrapper } from '@skylab-angular-shared/core';
import { UserRoleSynchronizerServiceBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@Wrapper(UserRoleSynchronizerServiceBase)
export class UserRoleSynchronizerService {
    public constructor(
        http: Http
    ) { }
}
